// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Icsq+","loader":"Loader_loader__615JF","spin":"Loader_spin__BHte+"};